import React from "react";
import "./PortfolioFilter.css";

const PortfolioFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="portfolio-filter">
      {categories.map((category) => (
        <button
          key={category.id}
          className={`filter-btn ${activeCategory === category.id ? "active" : ""}`}
          onClick={() => onCategoryChange(category.id)}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
};

export default PortfolioFilter;
